<template>
	<div>
		<div v-if="dashboardData && dashboardData !== null" :key="refreshKey">
			<h1>{{ $t('routerTitles.Dashboard') }}</h1>
			<el-card class="mb-10">
				<div class="row1">
					<div class="disp-flex">
						<div :key="refreshKey" class="pr-5">
							<div>
								<el-date-picker
									v-model="dateRange"
									size="mini"
									type="daterange"
									align="right"
									unlink-panels
									range-separator="-"
									:start-placeholder="$t('startDate')"
									:end-placeholder="$t('endDate')"
									:picker-options="pickerOptions"
									format="dd-MM-yyyy"
									@change="handleDateRangeChange"
								>
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</el-card>
			<el-row :gutter="10" class="mb-10">
				<el-col :span="24">
					<el-card style="height: 180px">
						<h3 class="mb-10">{{ $tc('documents', 777) }}</h3>
						<div class="row2">
							<div class="disp-flex">
								<div class="pt-15 pb-15 b-r-blue pl-10 pr-10">
									<div class="mb-5">
										<b class="fs-18">
											{{ dashboardData.dashboard_totals[0].count_invoiced | formatBigNumber }}
										</b>
										<br />
										<span class="smaller">{{ $t('totalInvoiced') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].total_invoiced | risoltoNumberFormatter }}
									</div>
								</div>
								<div class="pt-15 pb-15 b-r-blue pl-10 pr-10">
									<div class="mb-5">
										<b class="fs-18">
											{{ dashboardData.dashboard_totals[0].count_invoiced_paid | formatBigNumber }}
										</b>
										<br />
										<span class="smaller">{{ $t('totalPaid') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].total_invoiced_paid | risoltoNumberFormatter }}
									</div>
								</div>
								<div class="pt-15 pb-15 b-r-blue pl-10 pr-10">
									<div class="mb-5">
										<b class="fs-18">
											{{ dashboardData.dashboard_totals[0].count_invoiced_unpaid | formatBigNumber }}
										</b>
										<br />
										<span class="smaller">{{ $t('totalUnpaid') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].total_invoiced_unpaid | risoltoNumberFormatter }}
									</div>
								</div>
								<div class="pt-15 pb-15 b-r-blue pl-10 pr-10">
									<div class="mb-5">
										<b class="fs-18">
										&nbsp;
										</b>
										<br />
										<span class="smaller">{{ $t('totalOpenBalance') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].open_balance | risoltoNumberFormatter }}
									</div>
								</div>
								<div class="pt-15 pb-15 b-r-blue pl-10 pr-10">
									<div class="mb-5">
										<b class="fs-18">
										&nbsp;
										</b>
										<br />
										<span class="smaller">{{ $t('totalOpenBalanceNonOverdue') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].open_balance_non_overdue | risoltoNumberFormatter }}
									</div>
								</div>
								<div class="pt-15 pb-15 pl-10 ">
									<div class="mb-5">
										<b class="fs-18">
										&nbsp;
										</b>
										<br />
										<span class="smaller">{{ $t('totalOpenBalanceOverdue') }}</span>
									</div>
									<div class="fs-18">
										{{ dashboardData.dashboard_totals[0].open_balance_overdue | risoltoNumberFormatter }}
									</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mb-10">
				<el-col :span="12">
					<el-card style="height: 180px">
						<h3 class="mb-10">{{ $tc('recipient', 777) }}</h3>
						<el-alert :title="`${$t('totalRecipients')}`" type="success" show-icon :closable="false">
							<div>
								<span style="font-size:25px">{{ dashboardData.total_recipients.aggregate.count | formatBigNumber }}</span>
							</div>
						</el-alert>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card style="height: 180px">
						<h3 class="mb-10">{{ $tc('action', 777) }}</h3>
						<div class="disp-flex mb-10">
							<div style="width: 25%;"></div>
							<div style="width: 25%; color: #ff4949"><strong>{{ $t('open') }}</strong></div>
							<div style="width: 25%; color: #13ce66">
								<strong> {{ $t('done') }}</strong>
							</div>
						</div>
						<div class="disp-flex mb-5">
							<div style="width: 25%;">
								<svg-icon style="color: #4EB0B9" icon-class="at-solid"> </svg-icon>&nbsp;
								<span style="color: #4EB0B9">Email</span>
							</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_email_open.aggregate.count }}</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_email_done.aggregate.count }}</div>
						</div>
						<div class="disp-flex mb-5">
							<div style="width: 25%;">
								<svg-icon style="color: #4EB0B9" icon-class="envelope-solid"> </svg-icon>
								&nbsp;
								<span style="color: #4EB0B9">{{ $t('postal') }}</span>
							</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_mail_open.aggregate.count }}</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_mail_done.aggregate.count }}</div>
						</div>
						<!-- TODO: ADD PEPPOL -->
						<div class="disp-flex mb-5">
							<div style="width: 25%;">
								<svg-icon style="color: #4EB0B9" icon-class="phone-solid"> </svg-icon>&nbsp;
								<span style="color: #4EB0B9">{{ $t('phone') }}</span>
							</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_phone_open.aggregate.count }}</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_phone_done.aggregate.count }}</div>
						</div>
						<div class="disp-flex">
							<div style="width: 25%;">
								<svg-icon style="color: #4EB0B9" icon-class="sms-solid"> </svg-icon>&nbsp;
								<span style="color: #4EB0B9">SMS</span>
							</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_sms_open.aggregate.count }}</div>
							<div style="width: 25%;">{{ dashboardData.total_actions_sms_done.aggregate.count }}</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row>
				<div class="mb-500">
					<section>
						<el-card>
							<h3 class="mb-0">{{ $t('Charts.aging_balance') }}</h3>
							<aging-balance :date-range="dateRange"> </aging-balance>
						</el-card>
					</section>
				</div>
			</el-row>
		</div>
		<div v-else-if="dashboardData === null">
			No data available
		</div>
		<div v-else class="text-center">
			<div style="height:100px"></div>
			<loader class="mt-50 mb-50"> </loader>
			<div style="height:100px"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import AgingBalance from '@/components/_AgingBalance';
import Logging from '@/logging';
import Loader from '@/components/_Loaders/index.vue';
import { gql } from 'graphql-tag';

const DASHBOARD = gql`
query DashboardQuery(
	$participant: uuid!
	$legal_entity: uuid
	$startDate: date
	$endDate: date
	$startTimestamp: timestamptz
	$endTimestamp: timestamptz
  ) {
	total_recipients: risolto_recipient_aggregate(
	  where: { 
	  	participant: { _eq: $participant } 
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
	}
  ) {
	  aggregate {
		count
	  }
	}
	dashboard_totals:risolto_dashboard_totals_v2(
		args:{
			q_participant:$participant
			q_legal_entity:$legal_entity
			q_issue_date_from: $startDate
			q_issue_date_until: $endDate
		}
	){
		count_invoiced:data(path:"count_invoiced")
		total_invoiced:data(path:"total_invoiced")
	
		count_invoiced_paid:data(path:"count_invoiced_paid")
		total_invoiced_paid:data(path:"total_invoiced_paid")
		
		count_invoiced_unpaid:data(path:"count_invoiced_unpaid")
		total_invoiced_unpaid:data(path:"total_invoiced_unpaid")  
	
		open_balance:data(path:"open_balance")
		open_balance_non_overdue:data(path:"open_balance_non_overdue")
		open_balance_overdue:data(path:"open_balance_overdue")
	}
	total_actions_phone_open: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: PHONE }
		status: { _eq: OPEN }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_phone_done: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: PHONE }
		status: { _eq: DONE }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_email_open: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: EMAIL }
		status: { _eq: OPEN }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_email_done: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: EMAIL }
		status: { _eq: DONE }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_mail_open: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: MAIL }
		status: { _eq: OPEN }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_mail_done: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: MAIL }
		status: { _eq: DONE }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_sms_open: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: SMS }
		status: { _eq: OPEN }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
	total_actions_sms_done: risolto_action_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		channel: { _eq: SMS }
		status: { _eq: DONE }
		created_at: { _gte: $startTimestamp, _lte: $endTimestamp }
	  }
	) {
	  aggregate {
		count
	  }
	}
  }  
`;

export default {
	name: 'DashboardAdmin',
	components: {
		AgingBalance,
		Loader
	},
	data() {
		return {
			refreshKey: Math.floor(Math.random() * 1000),
			dashboardData: undefined,
			dateRange: [],
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t('lastWeek'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: this.$t('lastMonth'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30.5);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: this.$t('last3Months'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: this.$t('last6Months'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: this.$t('lastYear'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			}
		};
	},
	computed: {
		...mapGetters(['selectedParticipantStore', 'selectedLegalEntityStore'])
	},
	watch: {
		selectedParticipantStore: async function() {
			const queryVars = {
				participant: this.selectedParticipantStore,
				legal_entity: this.selectedLegalEntityStore
			};
			this.getDashboardData(queryVars);
		}
	},
	async created() {
		const today = new Date();
		const lastYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

		this.dateRange = [lastYear, today];

		if (this.selectedParticipantStore) {
			const queryVars = {
				participant: this.selectedParticipantStore,
				legal_entity: this.selectedLegalEntityStore
			};
			this.getDashboardData(queryVars);
		}
	},
	methods: {
		handleDateRangeChange(val) {
			const startDate = `${new Date(val[0]).getFullYear()}-${new Date(val[0]).getMonth() + 1}-${new Date(val[0]).getDate()}`;
			const endDate = `${new Date(val[1]).getFullYear()}-${new Date(val[1]).getMonth() + 1}-${new Date(val[1]).getDate()}`;
			const startDateTimestamp = val[0];
			const endDateTimestamp = val[1];

			const queryVars = {
				participant: this.selectedParticipantStore,
				legal_entity: this.selectedLegalEntityStore,
				startDate,
				endDate,
				startTimestamp: startDateTimestamp,
				endTimestamp: endDateTimestamp
			};

			this.getDashboardData(queryVars);
		},
		async getDashboardData(queryVars) {
			try {
				const result = await this.$apollo.query({
					query: DASHBOARD,
					variables: queryVars,
					fetchPolicy: 'no-cache'
				});
				if (result.data) {
					// console.log('result.data: ', result.data);
					this.dashboardData = result.data;
				} else {
					this.dashboardData = null;
					throw new Error('No data available on result from DASHBOARD query');
				}
			} catch (e) {
				Logging.error('Error: ', e);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
	padding: 32px;
	//   background-color: #FFF !important;
	position: relative;

	.chart-wrapper {
		background: #fff;
		padding: 16px 16px 0;
		margin-bottom: 32px;
	}
}

@media (max-width: 1024px) {
	.chart-wrapper {
		padding: 8px;
	}
}

.chartJsInvoices {
	width: 100%;
	max-height: 400px;
}

.row2 {
	padding: 5px 10px;
	color: #ffffff;
	background-color: #e8f4ff;
	color: #1682e6;
	border-radius: 10px;

	.smaller {
		font-size: 14px;
	}

	b {
		color: #1682e6;
	}
}
</style>
